<template>
  <div>
    <h1 class="common__main-title">Mail Template List</h1>
    <div>
      <SearchConditions class="search" @changeConditions="changeConditions" />
      <div class="d-flex mb-3">
        <b-button pill variant="primary" :to="{ name:'MailTemplateAdd' }" class="mr-2">
          Create
        </b-button>
      </div>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="changePage" class="mb-2" />
      </div>
      <MailTemplateTable :templates="templates"/>
      <div class="pager-box">
        <PagerComponent v-model="pager" @changePage="changePage" />
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import PagerComponent from '@/components/parts/Pager.vue'
import MailTemplateTable from '@/components/parts/mails/templates/MailTemplateTable.vue'
import SearchConditions from '@/components/parts/mails/templates/SearchConditions.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { MailTemplate, MailTemplateConditions, MailTemplatesState } from '@/store/mails/templates/types'
import { Pager } from '@/store/pager.types'

export default Vue.extend({
  components: {
    SearchConditions,
    PagerComponent,
    MailTemplateTable,
    Loading,
  },

  data(): {
    isLoading: boolean,
    conditions: MailTemplateConditions|null,
    } {
    return {
      isLoading: false,
      conditions: null,
    }
  },

  created(): void {
    this.fetch()
  },

  computed: {
    templates(): MailTemplate[] {
      return (this.$store.state.mails.templates as MailTemplatesState).templates
    },
    pager(): Pager {
      return (this.$store.state.mails.templates as MailTemplatesState).pager
    },
  },

  methods: {
    fetch(page: number = 1): void {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      this.$store.dispatch('fetchMailTemplates', {
        conditions: this.conditions,
        page,
      })
        .finally(() => {
          this.isLoading = false
        })
    },

    changeConditions(conditions: MailTemplateConditions): void {
      this.conditions = conditions
      this.fetch()
    },

    changePage(page: number): void {
      this.fetch(page)
    },
  },
})
</script>
